module.exports = __webpack_public_path__ + "a20dced519a0329a2ad6d73166f5ee18.svg";